import request from "../utils/request"

export default {
    getBannerList() {
        return request({
            url: `/banner?ac=list`,
            method: 'get'
        })
    },

    getCommunityList() {
        return request({
            url: `/community?ac=list`,
            method: 'get'
        })
    }
}
